import { api } from "./client";

// MARK: - Follow

export const followApi = {
  follow: (companyId: string) =>
    api.post<{ success: boolean }>(`/companies/${companyId}/follow`, { company_id: companyId }),
  unfollow: (companyId: string) =>
    api.delete<{ success: boolean }>(`/companies/${companyId}/follow`),
  list: () =>
    api.get<{ company_ids: string[] }>("/companies/followed"),
};

// MARK: - Tags

export const tagsApi = {
  list: (companyId: string) =>
    api.get<{ companyId: string; tags: string[] }>(`/companies/${companyId}/tags`),
  add: (companyId: string, tags: string[]) =>
    api.post<{ companyId: string; added: number; tags: string[] }>(`/companies/${companyId}/tags`, { tags }),
  search: (tags: string, limit?: number) =>
    api.get<{ companies: unknown[]; count: number; tags: string[] }>(
      `/companies/search-tags?tags=${encodeURIComponent(tags)}${limit ? `&limit=${limit}` : ""}`,
    ),
  listAll: () =>
    api.get<{ companies: unknown[]; count: number }>("/companies/tagged"),
};

// MARK: - Reviews

export interface Review {
  id: string;
  companyId: string;
  rating: number;
  text?: string;
  authorId?: string;
  authorType: string;
  createdAt: string;
  photoUrls?: string[];
}

export interface ReviewsResponse {
  reviews: Review[];
  averageRating?: number;
  totalReviews?: number;
}

export const reviewsApi = {
  list: (companyId: string) =>
    api.get<ReviewsResponse>(`/companies/${companyId}/reviews`),
  submit: (companyId: string, data: { rating: number; text?: string; photoUrls?: string[] }) =>
    api.post<{ review: Review }>(`/companies/${companyId}/reviews`, data),
};
